import React, { useState, useEffect } from "react";
import logoWeb from "../../assets/images/others/host-side-images/logo-web.png";
import { IoIosArrowDown } from "react-icons/io";
import NavbarDrawer from "../drawers/host-side/NavbarDrawer";
import { ReactComponent as Notification } from "../../assets/images/svgs/notification-red.svg";
import { ReactComponent as UserIconNav } from "../../assets/images/svgs/nav-user-icon.svg";
import NotificatinDrawer from "../drawers/host-side/NotificatinDrawer";
import { NavLink, useNavigate } from "react-router-dom";
import { siteRoutes } from "../../utils/helpers/enums/routes";
import AttendeeNavbarDrawer from "../drawers/attendee-side/AttendeeNavbarDrawer";
import RsvpNavbarDrawer from "components/drawers/rsvp-side/RsvpNavbarDrawer";
import useStore from "hooks/useStore";

const RsvpNavbar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [notificationDrawer, setNotificationDrawer] = useState<boolean>(false);
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const navigate = useNavigate();
  const { getUserProfilePic, getUserFullName } = useStore();
  const userProfilePic = getUserProfilePic();
  const userFullName = getUserFullName();

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const toggleNotificationDrawer = () => {
    setNotificationDrawer(!notificationDrawer);
  };

  useEffect(() => {
    const handleScroll = () => {
      // Use a small threshold to prevent flickering
      if (window.scrollY > 10) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* Navbar */}
      <nav
        className={`
        w-full z-50 
        bg-white
        transition-all duration-500 ease-in-out
        ${
          isSticky
            ? "fixed top-0 left-0 shadow-lg py-2 backdrop-blur-sm bg-white/95"
            : "relative shadow-none py-3 bg-white"
        }
      `}
      >
        <div className="container-navbar flex justify-between items-center transition-all duration-500 ease-in-out">
          <div className="flex items-center">
            <img
              onClick={() => {
                navigate(siteRoutes.rsvpHome);
              }}
              src={logoWeb}
              alt="logo"
              className="h-8 cursor-pointer"
            />
          </div>
          <div className="flex items-center gap-4 md:gap-6 lg:gap-10">
            {/* Links */}
            <div className="hidden md:flex items-center gap-4 md:gap-6 lg:gap-10 ">
              <NavLink
                to="/rsvp/communities"
                className={({ isActive }) =>
                  isActive ? "text-rsvpGreen" : "text-darkBlueText"
                }
              >
                Communities
              </NavLink>

              <NavLink
                to="/rsvp/experiences"
                className={({ isActive }) =>
                  isActive ? "text-rsvpGreen" : "text-darkBlueText"
                }
              >
                Experiences
              </NavLink>

              <button
                onClick={toggleNotificationDrawer}
                className="text-blackie"
              >
                <Notification />
              </button>
            </div>

            <button
              onClick={toggleDrawer}
              className="flex items-center gap-2 text-blackie"
            >
              <img
                className="w-8 h-8 rounded-full object-cover "
                src={userProfilePic}
                alt="dp"
              />

              <span className="hidden md:block text-primaryBlueText capitalize">
                {userFullName}
              </span>
              <IoIosArrowDown className="text-blackie" />
            </button>
          </div>
        </div>
      </nav>

      {/* Drawer Components */}
      <RsvpNavbarDrawer isOpen={drawerOpen} onClose={toggleDrawer} />
      <NotificatinDrawer
        isOpen={notificationDrawer}
        onClose={toggleNotificationDrawer}
      />
    </div>
  );
};

export default RsvpNavbar;
